import { eLogin, ENU_LOGIN_SENCE, iLogin, RUNTIME_ENV, UserInfo } from '@cap/account';
import Cookies from 'js-cookie';
import qs from 'query-string';
import { getWindow } from '@cap/ssr-common-utils';
import { loginConfig } from './const';
import { logger } from '../logger';
import { isBiz } from '../account';
import { getCommonParams } from '../urlHelper';
import { isMobile } from '../uaHelper';

interface IGoLoginOptions {
  backUrl?: string;
  isReplace?: boolean;
  isReload?: boolean;
  isLogout?: boolean;
  isChangeAccount?: boolean;
}

const window = getWindow();
let currentEnv = RUNTIME_ENV.PRODUCTION;
const bizBgSource = 'biz_bg_source';
const IS_PROD = (env: RUNTIME_ENV) =>
  [RUNTIME_ENV.ST, RUNTIME_ENV.STAGING, RUNTIME_ENV.PROD, RUNTIME_ENV.PRODUCTION].includes(env);
const IS_B_BIZ = isBiz(window.location.host);
let userInfoLoacl: UserInfo | null = null;

const login = (() => {
  return IS_B_BIZ ? eLogin : iLogin;
})();

function goILogin(options: IGoLoginOptions) {
  const {
    backUrl = window.location.href,
    isReplace = false,
    isReload = true,
    isChangeAccount = false,
  } = options || {};
  const login_change_account = isChangeAccount ? 'changeAccount' : ''; // 是否切换账号登录
  // 重新生成落地页地址
  const targetUrlObj = qs.parseUrl(backUrl);
  const targetUrl = qs.stringifyUrl({
    ...targetUrlObj,
    query: {
      ...getCommonParams(),
      ...targetUrlObj.query,
      fromSource: isMobile() ? ENU_LOGIN_SENCE.ILOGIN : ENU_LOGIN_SENCE.PCLOGIN,
      login_change_account,
    },
  });

  iLogin.login({
    backUrl: targetUrl,
    isReplace,
    isChangeAccount,
    isReload,
    env: currentEnv,
    bizline: 'mtdx',
  });
}

async function goELogin(options: IGoLoginOptions) {
  const {
    backUrl = window.location.href,
    isLogout = false,
    isReplace = false,
    isReload = true,
  } = options || {};
  if (isLogout) {
    try {
      await eLogin.logout({ backUrl: '', autoRedirectLogin: false });
    } catch (err) {
      logger.log(err);
    }
  }

  // 重新生成落地页地址
  const targetUrlObj = qs.parseUrl(backUrl);
  targetUrlObj.query.BSID = null;
  delete targetUrlObj.query.BSID;
  targetUrlObj.query.fromSource = ENU_LOGIN_SENCE.ELOGIN;
  const targetUrl = qs.stringifyUrl(targetUrlObj);
  const bgSource = sessionStorage.getItem(bizBgSource) || undefined;

  setTimeout(async () => {
    eLogin.login({
      backUrl: targetUrl,
      bgSource,
      isReload,
      isReplace,
      env: currentEnv,
      bizline: 'mtdx',
    });
  }, 30);
}

async function goLogin(options: IGoLoginOptions = {}) {
  if (IS_B_BIZ) return goELogin(options);
  return goILogin(options);
}

async function logout(backUrl = window.location.href, autoRedirectLogin = false) {
  if (IS_B_BIZ) {
    // 清楚poiId信息
    backUrl = (backUrl || '').replace(/poiId=[^&]*/gi, '');
  }
  return login.logout({
    backUrl,
    autoRedirectLogin,
  });
}

const getUserInfo = async () => {
  const userInfo = await login.getUserInfo();
  if (userInfo && !userInfo?.avatarUrl) {
    userInfo.avatarUrl = 'https://p0.meituan.net/mtdxweb/mtdx_default_avatar_v2.png';
  }
  userInfoLoacl = userInfo;
  return userInfo;
};

export const getBizUserInfo = async (): Promise<UserInfo | null> => {
  let userInfo = null;
  if (IS_B_BIZ) {
    userInfo = await getUserInfo();
  }
  return userInfo;
};

const getUserInfoSync = () => {
  return userInfoLoacl;
};

const isLogin = async () => {
  const checkLogin = await login.checkLogin();
  return checkLogin;
};

const judgeLogin = async () => {
  const userInfo = await getUserInfo();
  if (!userInfo) {
    goLogin();
    return null;
  }
  return userInfo;
};

const init = async (props: { env: RUNTIME_ENV }) => {
  const { env } = props;
  currentEnv = env;
  const { risk_platform, risk_partner, risk_app, risk_level } = loginConfig();
  const opts: any = {
    bizline: 'mtdx',
    env,
    // 培训公众号授权登录
    officialAccount: 14,
    bgSource: Cookies.get(bizBgSource) || sessionStorage.getItem(bizBgSource) || undefined,
    risk_app,
    risk_level,
    risk_partner,
    risk_platform,
    sameSite: !IS_PROD(env),
  };
  // 是否使用美团公众号搜起登录。通过lion配置，方便降级到美团公众号
  if (window.CLOGIN_USE_PEIXUN_WXAPP === false || window.CLOGIN_USE_PEIXUN_WXAPP === 'false') {
    // 培训公众号授权登录
    delete opts.officialAccount;
  }
  if (IS_B_BIZ) {
    return eLogin.init({
      ...opts,
    });
  }
  return Promise.all([
    eLogin.init({
      ...opts,
      setLoginTypeToCookie: false,
    }),
    iLogin.init(opts),
  ]);
};

export const loginNewWrapper = {
  init,
  getUserInfo,
  getUserInfoSync,
  getBizUserInfo,
  goLogin,
  logout,
  isLogin,
  judgeLogin,
};
